import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { 
  InputGroup, 
  Input, 
  FormGroup, 
  InputGroupAddon 
} from 'reactstrap';
import { OFFER_DEPOSIT, OFFER_GAP } from '../../config';
import { isNumeric } from '../../helpers/regex';
import { hasError, convertToRupiah } from '../../utils/Helpers';
import styled from 'styled-components';
import classNames from 'classnames';
import { connect } from "react-redux"

const VALIDATE_AMOUNT_DELAY = 3000;

//round down multiple 50000
// const fixingAmount = value => {
//   if(isNumeric(value)) {
//     let parsed = parseFloat(value);
//     parsed -= (value % OFFER_GAP)
//     return parsed < OFFER_GAP? OFFER_GAP: parsed;
//   }
//   return value;
// }

//round up multiple 50000
const fixingAmount = value => {
  if(isNumeric(value)) {
    let parsed = parseFloat(value);
    parsed -= (value % OFFER_GAP)
    let summary = parsed + OFFER_GAP 
    let multipleGAP = value % OFFER_GAP;

    return parsed < OFFER_GAP? OFFER_GAP: (multipleGAP===0? parsed: summary);
  }
  return value;
}

class InputOffer extends Component {
  constructor(props){
    super(props);
    this.state = {
      intervalKeyDown: null,
      isValidating: false
    }
  }

  onKeyPress = ev => {
    const { intervalKeyDown } = this.state;
    const { ratio } = this.props 
    if(ratio !== 1) return;

    //rounding up is for indonesian only
    if(ev.charCode >=48 && ev.charCode <= 57){
      if(intervalKeyDown) clearTimeout(intervalKeyDown);
      const newIntervalKeyUp = setTimeout(()=>{
        this.setState({
          intervalKeyDown: null,
          isValidating: false
        })
        this.onFixingAmount();
      }, VALIDATE_AMOUNT_DELAY)
      this.setState({ intervalKeyDown: newIntervalKeyUp, isValidating: true })
    }
    else{
      if(intervalKeyDown) clearTimeout(intervalKeyDown);
    }
  }

  onBlur = () => {
    const { ratio } = this.props
    const { intervalKeyDown } = this.state;
    if(intervalKeyDown) clearTimeout(intervalKeyDown);
    this.setState({
      intervalKeyDown: null,
      isValidating: false
    })

    //rounding up is for indonesian only
    if(ratio === 1)
    this.onFixingAmount();
  }

  onFixingAmount = () => {
    const { _bidAmount } = this.props;
    this.props.handleSetBidAmount(fixingAmount(_bidAmount));
  }

  _renderInputMessage() {
    const  { _error, _messageField } = this.props;
    
    const isError = _error !== null && hasError(_error.errors, 'bidAmount');
    const message = isError? _error.errors['bidAmount'][0]: 
      (hasError(_messageField, 'bidAmount')? 
        _messageField['bidAmount']: null);

    return(
      <p className={classNames({'text-left text-danger': isError, 'text-right text-success': !isError, 'd-none': message === null })}>
        { message }
      </p>
    )
  }

  componentWillUnmount(){
    const { intervalKeyDown } = this.state;
    if(intervalKeyDown) clearTimeout(intervalKeyDown);
  }

  render(){
    const { currency } = this.props;
    const limit = (parseInt(this.props.dataAuth.userdata.balance) < OFFER_DEPOSIT);

    return(
      <div ref={ref => this.containerRefs = ref} className="sneaker-info-container offer">
        <div className="offer-content-middle">
          <p>Your Offer</p>
          <FormGroup className="offer-input">
            <InputGroup >
              <InputGroupAddon addonType="prepend">{currency}</InputGroupAddon>
              <Input
                name="_bidAmount"
                value={convertToRupiah(parseInt(this.props._bidAmount))}
                onChange={this.props._handleBidAmount}
                onKeyPress={this.onKeyPress}
                onBlur={this.onBlur}
              />
            </InputGroup>
          </FormGroup>
          { this._renderInputMessage() }
        </div>
        <div className="offer-content-bottom" onClick={this.props.handleTermsOffer}>
          <p className="text-offer-top">How does OFFER work?</p>
          {
            limit?
              <p className="text-offer-bottom">You have insufficient Kick Credit balance. Please meet the <span>requirement</span> to make an offer.</p>
            :
            null
          }
        </div>
        
      </div>  
    )
  }
}
const mapStateToProps = state => ({ 
  ratio: state.dataAuth.userCurrency.ratio,
  currency: state.dataAuth.userCurrency.currency
}) 
export default connect(mapStateToProps)(InputOffer);